<template>
  <search @search="search" v-model="searchValue">
    <my-refresh-more
      ref="refresh"
      slot="content"
      v-model="liveList"
      :pageSize="10"
      :getParams="getParams"
      :getList="getList"
    >
      <div slot="list" class="goods-list">
        <div
          v-for="(item, index) in liveList"
          :key="index"
          class="goods-item"
          @click="navToDetailPage(item)"
        >
          <div class="image-wrapper">
            <van-image lazy-load
              class="image-wrapper-image"
              :src="item.cover.length>0?item.cover[0]:''"
              mode="aspectFill"
            ></van-image>
          </div>
          <div class="span-wrapper">
            <span class="title clamp">{{item.name}}</span>
            <span class="price-box">{{item.startTime}}</span>
            <div class="price-box">
              <div>
                <span
                  class="price"
                >{{item.type==1?'免费':item.type==2?'¥'+(item.marketingCampaignPrice?item.marketingCampaignPrice:item.price):item.type==3?'加密':''}}</span>
                <van-tag v-if="item.marketingCampaignType==1" type="danger">团购价</van-tag>
                <van-tag v-if="item.marketingCampaignType==2" type="danger">限时折扣</van-tag>
              </div>
              <span>{{item.state==1?(item.isLiving?'直播中':''):(item.state==2?'结束':'')}}</span>
            </div>
          </div>
        </div>
      </div>
    </my-refresh-more>
  </search>
</template>

<script>
import search from '../base.vue';
export default {
  components: {
    search
  },
  data () {
    return {
      searchValue: '',
      liveList: [],
    };
  },
  methods: {
    search (value) {
      this.searchValue = value
      this.$refs.refresh.refreshList()
    },
    getParams () {
      return { searchValue: this.searchValue }
    },
    getList (page, size, param) {
      let {
        searchValue
      } = param
      let params = {
        page: page,
        size: size,
        name: searchValue,
      }
      return new Promise((resolve, reject) => {
        this.$http.request(this.$http.pathMap.liveList, 'get', params).then(res => {
          resolve(res.data)
        })
      })
    },
    //详情
    navToDetailPage (item) {
      let id = item.id;
      this.$router.push({ path: '/onlinePages/live/live', query: { id } })
    },
  },
}
</script>

<style lang="scss" scoped>
.search-box {
  height: 45px;
  z-index: 21;
  width: 100%;
  padding: 2px 15px;

  input {
    height: 70upx;

    flex: 1;
    border-radius: 17px;
    background-color: rgb(248, 248, 248);
    padding: 5px 15px;
  }

  span {
    font-size: 15px;
    color: grey;
    height: 30px;
    line-height: 30px;
    padding-left: 30px;
  }
}

.pro-box {
  display: flex;
  align-items: center;
  margin-top: 5px;
  font-size: $uni-font-size-sm;
  color: $uni-font-size-base;
  padding-right: 5px;
}

.progress-box {
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 4px;
}

.navTabBar {
  position: fixed;
  left: 0;
  top: var(--window-top);
  padding-top: 40px;
  display: flex;
  width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.06);
  z-index: 10;

  .nav-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 15px;
    color: $font-color-dark;
    position: relative;

    &.current {
      color: $base-color;

      &:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 60px;
        height: 0;
        border-bottom: 2px solid $base-color;
      }
    }
  }

  .p-box {
    display: flex;
    flex-direction: column;

    .yticon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15px;
      height: 7px;
      line-height: 1;
      margin-left: 2px;
      font-size: 13px;
      color: #888;

      &.active {
        color: $base-color;
      }
    }

    .xia {
      transform: scaleY(-1);
    }
  }

  .cate-item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 40px;
    position: relative;
    font-size: 22px;

    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      border-left: 1px solid #ddd;
      width: 0;
      height: 18px;
    }
  }
}

/* 商品列表 */
.goods-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0 15px;
  background: #fff;

  .goods-item {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .image-wrapper {
    width: 110px;
    height: 110px;
    border-radius: 3px;
    overflow: hidden;

    .image-wrapper-image {
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }
  .span-wrapper {
    flex: 1;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .title {
    font-size: $uni-font-size-lg;
    color: $font-color-dark;
  }

  .price-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 10px;
    font-size: $uni-font-size-base;
    color: $font-color-light;
  }

  .price {
    font-size: $uni-font-size-base;
    color: var(--theme-font-color);
    line-height: 1;
  }
}
.van-tag {
  transform: scale(0.7);
}
</style>
